// Order js class used to add event listeners to the order form's info link

const $ = window.jQuery || {};

class Order {
  constructor() {
    this.init();
  }

  init() {
    this.eventListeners();
  }

  eventListeners() {
    $("#toggle-instructions").on("click", function () {
      $("#instructions-content").slideToggle();
    });
  }
}

export default Order;
